import useSWR from 'swr'
import type { Manager, Pipeline } from '@ludus/core'
import { listPipelines, type PipelineApiError } from '@/lib/api/pipelines.ts'
import { useManagers } from '@/shared/hooks/useManagers.ts'

/** Both pages read the managers and the active boards; one of them failing fails the screen. */
export function useManagersScreen(): {
  managers: Manager[]
  pipelines: Pipeline[]
  isLoading: boolean
  failure: PipelineApiError | undefined
} {
  const { managers, error, isLoading } = useManagers()
  const pipelines = useSWR<Pipeline[], PipelineApiError>('/pipelines', () => listPipelines())
  return {
    managers: managers ?? [],
    pipelines: pipelines.data ?? [],
    isLoading: isLoading || pipelines.isLoading,
    failure: error ?? pipelines.error,
  }
}
